import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from 'src/app/core/constants/app-constants';
import { ProblemFacade } from 'src/app/store/problem/facade';
import { getTimeLeft, ProblemModel } from 'src/app/store/problem/model';
import notify from 'devextreme/ui/notify';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from 'src/app/shared/guards/can-deactivate-guard';
import { confirm } from 'devextreme/ui/dialog';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-problem',
  templateUrl: './problem.component.html',
  styleUrls: ['./problem.component.scss'],
  standalone: false,
})
export class ProblemComponent implements OnInit, ComponentCanDeactivate {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private problemFacade = inject(ProblemFacade);
  translate = inject(TranslateService);
  private titleService = inject(Title);

  sourceProblem: ProblemModel;
  problem: ProblemModel;

  confirmActionMessage: string = '';
  dataWasChangeMessage: string = '';
  uploadUrl: string;

  allowedPictureExtensions = ['jpg', 'jpeg', 'png'];
  allowedFileExtensions = ['.jpg', '.jpeg', '.png'];
  isCreateMode: boolean = false;

  ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    this.translate.get('CONFITM_ACTION').subscribe(value => {
      this.confirmActionMessage = value;
    });

    this.translate.get('DATA_WAS_CHANGE').subscribe(value => {
      this.dataWasChangeMessage = value;
    });

    this.route.params.subscribe(params => {
      this.problemFacade.selected().subscribe(problem => {
        this.sourceProblem = { ...problem };
        this.problem = { ...problem };

        if (this.problem && !this.problem.id) {
          this.problem.isActive = true;
          this.problem.publishDate = new Date();
          this.problem.fixDate = new Date();
          this.problem.fixDate.setHours(this.problem.fixDate.getHours() + 3);
          this.isCreateMode = true;
        } else {
          this.isCreateMode = false;
        }

        this.uploadUrl = `/api/problems/${this.problem.id}/image`;
      });

      this.problemFacade.setSelected(+params['id']);
    });
  }

  fixDateComparison = () => {
    return this.problem.fixDate;
  };

  publishDateComparison = () => {
    return this.problem.publishDate;
  };

  getTimeLeft() {
    return getTimeLeft(this.problem);
  }

  onFormSubmit = function (e) {
    this.saveChange();

    e.preventDefault();
  };

  private saveChange() {
    if (this.problem.id) {
      this.problemFacade.saveProblem(this.problem);
    } else {
      this.problemFacade.createProblem(this.problem);
    }
  }

  close() {
    this.router.navigate(['/problems']);
  }

  convertImage(problem: ProblemModel): any {
    return this.problemFacade.convertImage(problem);
  }

  async onUploaded(event) {
    const response = JSON.parse(event.request.response);

    if (response.isSucceeded) {
      this.problemFacade.setSelected(this.problem.id);
      this.problemFacade.loadProblems();

      let caption = await this.translate.get('FILE_ADDED').toPromise();
      notify(caption, 'succes', 5000);
    }
  }

  problemSolved() {
    this.problemFacade.solvedProblem(this.problem.id);
  }

  isChanged(): boolean {
    return JSON.stringify(this.sourceProblem) !== JSON.stringify(this.problem);
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    if (this.isChanged()) {
      return confirm(this.dataWasChangeMessage, this.confirmActionMessage);
    } else {
      return true;
    }
  }

  onValueChanged() {
    if (this.isChanged()) {
      this.saveChange();
    }
  }
}
